var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.984 4.10522L12.3953 5.51655M11.8913 2.86188L8.07332 6.67988C7.87604 6.87688 7.7415 7.12787 7.68665 7.40122L7.33398 9.16655L9.09932 8.81322C9.37265 8.75855 9.62332 8.62455 9.82065 8.42722L13.6387 4.60922C13.7534 4.49449 13.8444 4.35828 13.9065 4.20838C13.9686 4.05847 14.0005 3.89781 14.0005 3.73555C14.0005 3.5733 13.9686 3.41263 13.9065 3.26273C13.8444 3.11282 13.7534 2.97662 13.6387 2.86188C13.5239 2.74715 13.3877 2.65614 13.2378 2.59405C13.0879 2.53196 12.9272 2.5 12.765 2.5C12.6027 2.5 12.4421 2.53196 12.2922 2.59405C12.1423 2.65614 12.006 2.74715 11.8913 2.86188Z",
    stroke: "#1F83FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 10.4997V12.4997C12.667 12.8533 12.5265 13.1924 12.2765 13.4425C12.0264 13.6925 11.6873 13.833 11.3337 13.833H4.00033C3.6467 13.833 3.30756 13.6925 3.05752 13.4425C2.80747 13.1924 2.66699 12.8533 2.66699 12.4997V5.16634C2.66699 4.81272 2.80747 4.47358 3.05752 4.22353C3.30756 3.97348 3.6467 3.83301 4.00033 3.83301H6.00033",
    stroke: "#1F83FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6be7812a6a19cef4a8db643ba2836688.svg";
export { ForwardRef as ReactComponent };